import React from 'react'
import { useCallback } from 'sb-hooks'
import { ce2, constants, snowplow } from 'common/helpers'

import { Button } from 'components/_new/controls'
import type { ButtonProps } from 'components/_new/controls'
import { openChangeFrequencyModal } from 'compositions/modals/changeFrequency'

import messages from './messages'


type ChangeFrequencyButtonProps = Partial<Pick<ButtonProps, 'className' | 'size' | 'title' | 'color' | 'fullWidth' | 'dataTestId' | 'onClick'>>

const ChangeFrequencyButton: React.FunctionComponent<ChangeFrequencyButtonProps> = (props) => {
  const {
    className, fullWidth, onClick,
    size = 'md',
    color = 'brand',
    title = messages.title,
    dataTestId = constants.testIds.profile.orderStatusButtons.changeFrequency,
  } = props

  const handleClick = useCallback((event) => {
    if (typeof onClick === 'function') {
      onClick(event)
    }

    ce2.set(2, constants.analyticsEvents.changeFrequencyClick)
    snowplow.track('Change frequency click')

    openChangeFrequencyModal({
      popup: 'change frequency button',
      withFeedback: true,
    })
  }, [ onClick ])

  return (
    <Button
      className={className}
      size={size}
      title={title}
      color={color}
      fullWidth={fullWidth}
      dataTestId={dataTestId}
      onClick={handleClick}
    />
  )
}


export default ChangeFrequencyButton
